import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ShieldCheck, ShieldX, Search } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const fmt = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" }) : "—");

export default function VerifyInternshipCertificate() {
  const { certNo } = useParams();
  const navigate = useNavigate();
  const [q, setQ] = useState(certNo || "");
  const [res, setRes] = useState(null);
  useEffect(() => {
    setQ(certNo || "");
    if (!certNo) { setRes(null); return; }
    api.get(`/internship/verify/${certNo}`).then(({ data }) => setRes({ ok: data }))
      .catch(() => api.get(`/certificates/verify/${certNo}`).then(({ data }) => setRes({ ok: { student_name: data.user_name, domain: data.course_title, completion_date: data.issued_at, cert_no: data.cert_no, course: true } }))
        .catch(() => setRes({ err: true })));
  }, [certNo]);
  const c = res?.ok;
  return (
    <div className="max-w-xl mx-auto px-6 py-16 min-h-[60vh]" data-testid="verify-certificate">
      <h1 className="font-heading text-3xl font-bold text-navy">Verify a VIRIKS Certificate</h1>
      <p className="text-muted-foreground mt-1 mb-6">Enter the certificate ID printed on the certificate.</p>
      <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); if (q.trim()) navigate(`/verify-certificate/${q.trim().toUpperCase()}`); }}>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="VRKIC-2026-XXXXXXXX" data-testid="vc-input" />
        <Button type="submit" className="viriks-navy text-white" data-testid="vc-submit"><Search size={15} className="mr-1" />Verify</Button>
      </form>
      {c && (
        <div className="mt-6 border border-emerald-200 bg-emerald-50 rounded-xl p-6" data-testid="vc-valid">
          <div className="flex items-center gap-2 text-emerald-700 font-semibold"><ShieldCheck size={20} /> Valid {c.course ? "course" : "internship"} certificate</div>
          <dl className="mt-4 grid grid-cols-[130px_1fr] gap-y-2 text-sm">
            <dt className="text-muted-foreground">Awarded to</dt><dd className="font-semibold">{c.student_name}</dd>
            <dt className="text-muted-foreground">{c.course ? "Course" : "Internship"}</dt><dd className="font-semibold">{c.domain}</dd>
            {c.duration && <><dt className="text-muted-foreground">Duration</dt><dd>{c.duration}</dd></>}
            {c.start_date && <><dt className="text-muted-foreground">Start date</dt><dd>{fmt(c.start_date)}</dd></>}
            <dt className="text-muted-foreground">Completed</dt><dd>{fmt(c.completion_date)}</dd>
            <dt className="text-muted-foreground">Certificate ID</dt><dd className="font-mono">{c.cert_no}</dd>
          </dl>
        </div>
      )}
      {res?.err && <div className="mt-6 border border-crimson/20 bg-crimson/5 rounded-xl p-6 text-crimson flex gap-2" data-testid="vc-invalid"><ShieldX size={20} /> No valid certificate found with this ID.</div>}
    </div>
  );
}
